// lib/auth-handler.ts
import { setAuthSession } from "./auth";

export const handleAuthResponse = (result: any) => {
  if (result?.token) {
    // Or whatever success condition you use
    setAuthSession(result);
    return { success: true, data: result };
  }
  throw new Error(result.message || "Authentication failed");
};
